import angular from 'angular'
import 'angular-ui-router'
import loanEnquiryCreateDynamicComponent from './loanEnquiryCreateDynamic.component'

export default angular.module('app.pages.admin.loanEnquiryCreateDynamic', ['ui.router'])
  .directive('adminLoanEnquiryCreateDynamic', loanEnquiryCreateDynamicComponent)
